<template>
  <div class="sdg common-bg" style="width: 100%; min-height: 100vh;">
    <div style="width: 100%;">
      <van-nav-bar fixed title="线下存款" left-arrow @click-left="$router.back()">
        <template #right>
          <img
            src="/static/newImg/deposit/comm_icon_cz_jl.svg"
            class="nav-record-icon"
            @click="$router.push('/rechargeRecord')"
            alt="充值记录"
          />
        </template>
      </van-nav-bar>
      <div style="height: 46px"></div>
      <!-- 存款方式选择 -->
      <div class="typelis">
        <div :class="pay_way == 'usdt' ? ' tyls atc' : 'tyls'" @click="changPayway('usdt')"><img src="/static/image/1595237922936176.png" alt="" />USDT</div>
        <div :class="pay_way == 'wechat' ? ' tyls atc' : 'tyls'" @click="changPayway('wechat')"><img src="/static/image/QuickWechat.png" alt="" />微信</div>
        <div :class="pay_way == 'alipay' ? ' tyls atc' : 'tyls'" @click="changPayway('alipay')"><img src="/static/image/icoAlipay2@3x.png" alt="" />支付宝</div>
      </div>

      <!-- 收款信息区域 -->
      <div class="pay-section">
        <!-- 标题：显示后台 content 字段 -->
        <div class="pay-title-row">
          <div class="pay-title">{{ channelData.title || payTitle }}</div>
        </div>

        <!-- 收款二维码 -->
        <div class="qr-box" v-if="channelData.payimg">
          <img :src="$imgUrl(channelData.payimg)" class="qr-img" @click="previewQr" />
          <div class="qr-tip">请扫描上方二维码进行付款</div>
        </div>

        <!-- 收款地址/账号（mch_id） -->
        <div class="addr-box" v-if="channelData.mch_id">
          <!-- 姓名/协议 备注 -->
          <div class="addr-name-row" v-if="channelData.mch_name">
            <span class="addr-name-label">{{ pay_way == 'usdt' ? '协议类型' : '收款人姓名' }}</span>
            <span class="addr-name-value">{{ channelData.mch_name }}</span>
          </div>
          <div class="addr-label">{{ addrLabel }}</div>
          <div class="addr-value-row">
            <span class="addr-value">{{ channelData.mch_id }}</span>
            <svg class="copy-icon" viewBox="0 0 24 24" width="0.35rem" height="0.35rem" fill="none" stroke="#d1ae52" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" @click="doCopy(channelData.mch_id)">
              <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
              <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
            </svg>
          </div>
        </div>

        <!-- 存款金额 -->
        <div class="amount-box">
          <div class="amount-label">存款金额</div>
          <van-cell-group>
            <van-field label="￥" v-model.number="amount" type="digit" :placeholder="`请输入存款金额 ${channelData.min_price || min_price} - ${channelData.max_price || max_price}`">
              <template #button><span style="color: #fff">元</span></template>
            </van-field>
          </van-cell-group>
          <div class="amount-tip" v-if="pay_way == 'usdt'">
            <span style="color: red; font-size: 0.43rem; margin-right: 10px">≈</span>
            {{ amount ? Math.floor((amount / ($store.state.userInfo.usdtrate || 7)) * 100) / 100 : '0.00' }} USDT ; 参考汇率：{{ $store.state.userInfo.usdtrate || 7 }}
          </div>
        </div>

        <!-- 上传付款凭证 -->
        <div class="upload-box">
          <div class="upload-label">上传付款凭证</div>
          <van-uploader
            v-model="proofImages"
            :max-count="1"
            :after-read="afterReadProof"
            :preview-full-image="true"
            accept="image/*"
          />
          <div class="upload-tip">请上传付款截图，支持 JPG/PNG 格式</div>
        </div>

        <!-- 温馨提示 -->
        <div class="tips-box">
          <div class="tips-label">温馨提示</div>
          <div class="tips-content">{{ tipsText }}</div>
        </div>
      </div>

      <!-- 提交按钮 -->
      <div style="margin: 0 auto; width: 86%; padding-bottom: 1rem;">
        <van-button type="info" style="margin-top: 20px; width: 100%" @click="payTest">立即存款</van-button>
        <div class="textcns" style="text-align: center; color: #999; padding: 10px 0">存款遇到问题？联系 <span @click="$parent.openKefu" style="color: #cf866b; display: inline-block; margin: 0 6px">人工客服</span> 解决</div>
      </div>
    </div>
  </div>
</template>
<script>
import { ImagePreview } from 'vant';
export default {
  name: 'recharge',
  data() {
    return {
      pay_way: 'usdt',
      amount: null,
      min_price: 100,
      max_price: 10000,
      proofImages: [],
      payImage: '',
      channelData: {},
    };
  },
  computed: {
    payTitle() {
      const map = { usdt: 'USDT收款', wechat: '微信收款', alipay: '支付宝收款' };
      return map[this.pay_way] || '收款';
    },
    addrLabel() {
      const map = { usdt: 'USDT地址', wechat: '微信账号', alipay: '支付宝账号' };
      return map[this.pay_way] || '收款地址';
    },
    tipsText() {
      if (this.pay_way == 'usdt') {
        return '请选择正确的USDT协议付款，若您选择错误的协议付款，平台将无法收到您的付款，为此我们不承担任何负责！';
      }
      return '请务必转账后再提交订单，转账金额需与存款金额一致，否则无法到账。';
    },
  },
  activated() {
    // keepAlive 缓存组件，每次进入页面都重新拉取当前存款方式的收款通道
    this.getChannelData(this.pay_way);
  },
  methods: {
    changPayway(val) {
      if (val == this.pay_way) return;
      this.pay_way = val;
      this.amount = null;
      this.proofImages = [];
      this.payImage = '';
      this.getChannelData(val);
    },
    getPayType(type) {
      const map = { usdt: 1, wechat: 2, alipay: 3 };
      return map[type] || 0;
    },
    getChannelData(type) {
      let that = this;
      that.showLoading();
      that.$apiFun
        .post('/api/getOfflineCode', { pay_type: that.getPayType(type) })
        .then(res => {
          that.hideLoading();
          if (res.code == 200) {
            that.channelData = res.data;
          } else {
            that.showTost(0, res.message || '获取收款通道失败');
            that.channelData = { id: 0, content: '', key: '', min_price: 100, max_price: 10000 };
          }
        })
        .catch(() => {
          that.hideLoading();
          that.channelData = { id: 0, content: '', key: '', min_price: 100, max_price: 10000 };
        });
    },
    afterReadProof(file) {
      let that = this;
      file.status = 'uploading';
      file.message = '上传中';
      let formData = new FormData();
      formData.append('file', file.file);
      that.$apiFun
        .post('/api/recharge/uploadProof', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then(res => {
          if (res.code == 200) {
            let relative = res.data;
            file.status = 'done';
            file.message = '';
            file.url = that.$imgUrl(relative);
            that.payImage = relative;
          } else {
            file.status = 'failed';
            file.message = res.message ? res.message : '上传失败';
            that.showTost(0, res.message ? res.message : '上传失败');
          }
        })
        .catch(() => {
          file.status = 'failed';
          file.message = '上传失败';
        });
    },
    previewQr() {
      if (this.channelData.payimg) {
        ImagePreview({
          images: [this.$imgUrl(this.channelData.payimg)],
          startPosition: 0,
        });
      }
    },
    payTest() {
      let that = this;
      let amt = Number(String(that.amount || '').replace(/[^\d.]/g, ''));
      if (isNaN(amt) || amt <= 0) {
        that.showTost(0, '请输入存款金额');
        return;
      }
      let minP = Number(String(that.channelData.min_price || that.min_price).replace(/[^\d.]/g, ''));
      let maxP = Number(String(that.channelData.max_price || that.max_price).replace(/[^\d.]/g, ''));
      if (amt < minP || amt > maxP) {
        that.showTost(0, `请输入金额在${that.channelData.min_price || that.min_price}-${that.channelData.max_price || that.max_price}之间！`);
        return;
      }
      if (!that.payImage) {
        that.showTost(0, '请上传付款凭证');
        return;
      }
      if (!that.channelData.id) {
        that.showTost(0, '收款通道加载中，请稍后重试');
        return;
      }
      let info = {
        amount: amt,
        pay_type: that.getPayType(that.pay_way),
        code_pay_id: that.channelData.id,
        payimg: that.payImage,
      };
      that.showLoading();
      that.$apiFun
        .post('/api/offlineRechargeSubmit', info)
        .then(res => {
          that.hideLoading();
          if (res.code == 200) {
            that.showTost(1, '提交成功，等待后台审核');
            that.amount = null;
            that.proofImages = [];
            that.payImage = '';
          } else {
            that.showTost(0, res.message || '提交失败');
          }
        })
        .catch(() => {
          that.hideLoading();
          that.showTost(0, '网络错误，请重试');
        });
    },
    doCopy(msg, toastMsg) {
      if (!msg) return;
      let cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = msg;
      document.body.appendChild(cInput);
      cInput.select();
      document.execCommand('copy');
      document.body.removeChild(cInput);
      this.showTost(1, toastMsg || '复制成功！');
    },
    showLoading() { this.$parent.showLoading(); },
    hideLoading() { this.$parent.hideLoading(); },
    showTost(type, title) { this.$parent.showTost(type, title); },
  },
};
</script>

<style lang="scss" scoped>
@import '../../static/css/2d87bbdbffeb4734e5c7.css';
@import '../../static/css/common.css';

.typelis {
  width: 95%;
  margin: 6px auto;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .tyls {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    border-radius: 10px;
    border: 1px solid #eee;
    color: #fff;
    text-align: center;
    width: calc(33% - 0.2rem);
    padding: 0.2rem 0;
    font-size: 0.3rem;
    margin-left: 0.15rem;
    img { width: 0.7rem; display: block; }
  }
  .tyls.atc {
    border: 1px solid #DFB372;
    color: #DFB372;
  }
}

.pay-section {
  width: 92%;
  margin: 0.2rem auto;
  background: #1a1a1a;
  border-radius: 0.15rem;
  padding: 0.3rem;
  box-sizing: border-box;
}

/* 顶部导航栏「充值记录」图标（与 depositNew 头部同款） */
.nav-record-icon {
  width: 0.5rem;
  height: 0.5rem;
  margin-right: 0.1rem;
  display: block;
}

/* 标题行 */
.pay-title-row {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.1rem 0 0.3rem;
}
.pay-title {
  font-size: 0.4rem;
  font-weight: 700;
  color: #DFB372;
  text-align: center;
}

.qr-box {
  text-align: center;
  padding: 0.2rem 0 0.3rem;
  .qr-img {
    width: 3.5rem;
    height: 3.5rem;
    border-radius: 0.1rem;
    object-fit: contain;
    background: #fff;
    padding: 0.1rem;
  }
  .qr-tip {
    font-size: 0.28rem;
    color: #999;
    margin-top: 0.15rem;
  }
}

.addr-box {
  padding: 0.2rem 0;
  border-top: 1px solid #333;
  border-bottom: 1px solid #333;
  margin: 0.1rem 0;
  .addr-name-row {
    display: flex;
    align-items: center;
    padding-bottom: 0.15rem;
    margin-bottom: 0.15rem;
    border-bottom: 1px dashed #444;
    .addr-name-label {
      font-size: 0.3rem;
      color: #999;
      margin-right: 0.2rem;
      flex-shrink: 0;
    }
    .addr-name-value {
      font-size: 0.34rem;
      color: #DFB372;
      font-weight: 600;
    }
  }
  .addr-label {
    font-size: 0.3rem;
    color: #999;
    margin-bottom: 0.1rem;
  }
  .addr-value-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .addr-value {
      font-size: 0.32rem;
      color: #fff;
      word-break: break-all;
      flex: 1;
      margin-right: 0.2rem;
    }
    .copy-icon {
      flex-shrink: 0;
      cursor: pointer;
    }
  }
}

.amount-box {
  padding: 0.2rem 0;
  .amount-label {
    font-size: 0.35rem;
    color: #fff;
    margin-bottom: 0.1rem;
  }
  .amount-tip {
    display: flex;
    align-items: center;
    font-size: 0.3rem;
    color: #a5a9b3;
    padding: 0.15rem 0;
  }
}

.upload-box {
  padding: 0.2rem 0;
  border-top: 1px solid #333;
  margin-top: 0.1rem;
  .upload-label {
    font-size: 0.35rem;
    color: #fff;
    margin-bottom: 0.15rem;
  }
  .upload-tip {
    font-size: 0.28rem;
    color: #999;
    margin-top: 0.1rem;
  }
}

.tips-box {
  padding: 0.2rem 0;
  border-top: 1px solid #333;
  margin-top: 0.1rem;
  .tips-label {
    font-size: 0.35rem;
    color: #fff;
    margin-bottom: 0.1rem;
  }
  .tips-content {
    font-size: 0.3rem;
    color: #a5a9b3;
    line-height: 0.5rem;
  }
}
</style>

<style scoped>
/deep/ .van-cell { background-color: #292A2C !important; color: #898989; border-radius: 0.1rem; border: 1px solid #666; }
/deep/ .van-cell-group { background-color: transparent !important; }
/deep/ .van-field__label { color: #fff !important; }
/deep/ .van-field__control { color: #fff !important; font-size: 0.35rem !important; }
/deep/ .van-uploader__upload { background-color: #292A2C !important; border: 1px solid #555 !important; }
/deep/ .van-uploader__preview-image { width: 2rem !important; height: 2rem !important; }
</style>



// WEBPACK FOOTER //
// src/components/recharge.vue